/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Image, ToolTip } from '@insticator/insticator-ui'; // iui-material
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/removeimageindicator/removeimageindicator_styles';



/* ========== ~~~~~~~~~~ REMOVE IMAGE INDICATOR ~~~~~~~~~~ ========== */
const Removeimageindicator = ({classes, handleRemoval}) => {
    return (
        <div className={`removeimageindicator ${classes.removeimageindicator}`} onClick={handleRemoval}>
            <ToolTip position={`top`} action={`mouseenter`} content={`Remove background image`}>
                    <img alt={'remove background'} src={`${url.image}/icon-remove-image-icon.svg`} />
            </ToolTip>
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Removeimageindicator);
